import { LENDER_WATERFALL_FACT_NAMES_NUMERIC } from "@trnsact/types-lender-waterfall/dist/models/LenderWaterfallFactNamesNumeric";
import { LENDER_WATERFALL_FACT_NAMES_STRING } from "@trnsact/types-lender-waterfall/dist/models/LenderWaterfallFactNamesString";
import { CriteriaValue } from "../types";

export function mapConditionsToCriteria(mappedConditions: any[]): CriteriaValue[] {
  return mappedConditions.map(condition => {
    const fact = condition.fact;

    if (fact in LENDER_WATERFALL_FACT_NAMES_NUMERIC) {
      return {
        fact,
        number: {
          min: condition.minValue ?? null,
          max: condition.maxValue ?? null,
        },
        boolean: { value: false },
        string: { value: [] },
        isRequiredToQuote: false,
      };
    }

    if (fact in LENDER_WATERFALL_FACT_NAMES_STRING) {
      return {
        fact,
        string: {
          value: condition.exactMatch?.map((value: any) => ({ label: value, value })) ?? [],
        },
        boolean: { value: false },
        number: { min: null, max: null },
        isRequiredToQuote: false,
      };
    }

    return {
      fact,
      boolean: { value: condition.value },
      string: { value: [] },
      number: { min: null, max: null },
      isRequiredToQuote: false,
    };
  });
}
